import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { SupplierStatusEnum } from '../enums/supplier-status.enum';
import { SupplierTypeEnum } from '../enums/supplier-type.enum';

/**
 * Supplier DTO for lists
 */
@CaslSubject(AppSubjectEnum.SUPPLIER)
export class SupplierListDto extends BaseDto {
  code!: string;
  status!: SupplierStatusEnum;
  type!: SupplierTypeEnum;
  contact!: TenantContactDto;
  tags?: TagListDto[] | null;
}
